import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Options } from 'ng5-slider';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { BiciVerMasAsistenciasComponent } from '../blocks/bici-ver-mas-asistencias/bici-ver-mas-asistencias.component';
import { BiciVerNumeroSerieComponent } from '../blocks/bici-ver-numero-serie/bici-ver-numero-serie.component';
import { ConfirmacionDatosComponent } from '../blocks/confirmacion-datos/confirmacion-datos.component';
import { ProteccionDatosComponent } from '../blocks/proteccion-datos/proteccion-datos.component';
import { TecnologiaTcComponent } from '../blocks/tecnologia-tc/tecnologia-tc.component';
import { formatNumber } from '@angular/common';

declare var fbq;
declare var gtag;

@Component({
  selector: 'app-cotizador-bici',
  templateUrl: './cotizador-bici.component.html',
  styles: []
})
export class CotizadorBiciComponent implements OnInit {
  data: any = {};
  errors: any = [];
  path: any = "";
  waTxt: any = "";

  isLoading: boolean = false;
  cotizador: any = null;
  coberturas: any = null;
  provincias: any = null;
  ocupaciones: any = null;
  nacionalidades: any = null;
  planes: any = null;
  planSeleccionado: any = null;
  ccHorario: any = "";
  isContactSelected: boolean = false;
  showNroSerie: boolean = false;

  sa: number = 0;
  min_sa: number = 0;
  max_sa: number = 0;

  options: Options = {
    step: 100,
    showSelectionBar: true,
    translate: (value: number): string => {
      return '$' + value;
    }
  };

  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {
    this.path = this.route.routeConfig.path;

    this.api.getCotizador("BI").subscribe(x => {
      window.scrollTo(0, 0);
      this.cotizador = x.data;
      this.getTopes();
    });

    let tmpCanal = document.location.href.split("?");

    if (tmpCanal[1]) {
      this.data.canal = tmpCanal[1];
    }

    this.api.getHorariosCC().subscribe(x => {
      this.ccHorario = x.data.mensaje;
    });

  }

  captcha(e: any) {
    this.data.captcha = e;
  }

  selectPlan(evt: any) {
    window.scrollTo(0, 0);

    this.planSeleccionado = evt.plan;
    this.data.plan = evt.plan.nombre;
    this.data.planId = evt.plan.productoId;
    this.data.cuota_mensual = evt.plan.cuota_mensual;

    localStorage.removeItem("nroserie");
    if(this.planSeleccionado.productoId >= 5){
      localStorage.setItem("nroserie","1");
    }

    this.trackEvent("Seleccionar", "Elige Plan", "Seleccionar Plan");

    this.updateLead(3);

  }

  getTopes() {
    this.api.getCoberturasTopes(this.cotizador.coberturaReferencia).subscribe(x => {

      const newOptions: Options = Object.assign({}, this.options);

      this.sa = parseInt(x.data.max) / 2;
      newOptions.ceil = parseInt(x.data.max);
      newOptions.floor = parseInt(x.data.min);
      newOptions.step = 100;

      this.options = newOptions;

      this.min_sa = x.data.min;
      this.max_sa = x.data.max;

      if(this.path == 'bici'){
        this.data.step = 1;
      }

      if(this.path == 'bici-gracias'){

        if (localStorage.getItem("waTxt")) {
          this.waTxt = localStorage.getItem("waTxt");
        }
       
        if(localStorage.getItem("tipoContacto")){
          if(localStorage.getItem("nroserie")){
            this.showNroSerie = true;
          }
          this.data.tipo_contacto = localStorage.getItem("tipoContacto");

          switch (this.data.tipo_contacto) {
            case "W":
              this.trackEvent("Seleccionar", "Form Completo", "WhatsApp");
              break;
            case "M":
              this.trackEvent("Seleccionar", "Form Completo", "Email");
              break;
            case "T":
              this.trackEvent("Seleccionar", "Form Completo", "Telefono");
              break;
          }

          this.data.step = 4;
          localStorage.removeItem("tipoContacto");
        }else{
          document.location.href="bici";
        }
   
      }
      
      if(this.path == 'bici-nps'){
        this.data.step = 5;
      }

      if(this.path == 'bici-unsuscribe'){
        this.data.step = 6;
      }

     /*
        this.data.apellido = "sadf";
        this.data.email = "rabinovich.sergio@gmail.com";
        this.data.nombre = "sadf";
        this.data.sa = 70000;
        this.data.telefono_numero = "56322414";
        this.data.telefono_prefijo = "011";
  
        this.cotizar();

     */
    });
  }

  ngOnInit() {
  }

  goToStep(step: number, el: string = "") {
    console.log(el);
    this.data.step = step;

    if (el == "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView();
      }, 500);
    }
  }

  cotizar() {

    this.spinner.show();


    this.data.sa = this.sa;
    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;

        this.api.getProductosRecomendadosByCobertura(this.cotizador.coberturaReferencia, this.sa).subscribe(x => {
          this.trackEvent("Seleccionar", "Home Datos Personales", "Cotizar");
          this.planes = x.data;
          this.goToStep(2);
          this.spinner.hide();
        });
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.goToStep(this.data.step, "secCotizador");
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });


  }

  doSelectTipoContactoRadio(tipoContacto: any){
    this.data.tipo_contacto = tipoContacto;
    this.isContactSelected = true;
  }

  finalizar() {
    this.trackEvent('Seleccionar', 'Medio Contacto', 'Finalizar');
    this.updateLead(4);
  }

  updateLead(stepTo: number) {
    window.scrollTo(0, 0);

    this.spinner.show();

    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {

        if (stepTo == 1){
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 2){
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 3) {
          this.trackEvent("Seleccionar", "Formulario", "Datos Completos", "Lead");
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 4) {
          if(this.data.tipo_contacto == "W"){
            let txt = '¡Hola! Coticé mi seguro de Bicicleta, el precio mensual es $' + formatNumber(this.data.cuota_mensual,'es-AR','1.0-0') + ' por una suma asegurada de $' + formatNumber(this.planSeleccionado.valor,'es-AR','1.0-0')  + ' en caso de robo y daño. Mi ID de cotización es ' + this.data.id + '.';
            let num = '+541162217106';
            let url = 'https://wa.me/' + num + '?text=' + txt;  
            let a = document.createElement("a");

            localStorage.setItem("waTxt", txt);
            
            document.body.appendChild(a);
            a.href = url;
            a.target = "_blank";
            a.click();
            document.body.removeChild(a);

          }

          let params = {
            lead: this.data,
            cotizacion: this.cotizador,
            tipo: this.data.tipo_contacto,
            plan: this.planSeleccionado
          }

          this.api.sendCotizacion(params).subscribe(ret => {
            localStorage.setItem("tipoContacto",this.data.tipo_contacto);
            this.spinner.hide();
            document.location.href="bici-gracias";
          });


          
        }

        
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });



  }

  showProteccionDatos() {
    this.modalService.open(ProteccionDatosComponent, { size: <any>'tecno-proteccion-datos bi' });
  }

  showTC() {
    this.modalService.open(TecnologiaTcComponent, { size: <any>'tecno-proteccion-datos bi' });
  }

  verMasAsistencias(){
    this.trackEvent('Seleccionar', 'Medio Contacto', 'Ver Asistencias');
    this.modalService.open(BiciVerMasAsistenciasComponent, { size: <any>'ver-mas-asistencias' });
  }

  verNroSerie(){
    this.modalService.open(BiciVerNumeroSerieComponent, { size: <any>'ver-mas-asistencias' });
  }

  trackEvent(gAction = null, gCategory = "", gLabel = "", FbEvent = null) {

    console.log("Categoria: " + gCategory + " | Accion: " + gAction + " | Etiqueta: " + gLabel);

    if (gAction) {
      gtag('event', gAction, {
        'event_category': gCategory,
        'event_label': gLabel
      });
    }

    if (FbEvent) {
      fbq('track', FbEvent);
    }
  }

}

